import { render, staticRenderFns } from "./PickCoordinate.vue?vue&type=template&id=bf385a04"
import script from "./PickCoordinate.vue?vue&type=script&lang=js"
export * from "./PickCoordinate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports